import request from "@/utils/request.js";

export const memberApi = {

	getMemberInfo(token) {

		const data = {
			"Seq": "20250526",
			"ID": "KS",
			"Key": "chk#az$ip7v6h!wrgm%2si",
			"Func": "getmemberdata",
			"data": {
				token: token || localStorage.getItem('logingCode')
			}
		}

		return request(data, 'KS')
	},

	regMember({
		Mobile,
		Area
	} = {}) {
		const data = {
			"Seq": "20250526",
			"ID": "KS",
			"Key": "chk#az$ip7v6h!wrgm%2si",
			"Func": "regmember",
			"data": {
				Area,
				Mobile
			}
		}

		return request(data, 'KS')
	},

	resPassword({
		Mobile, MemberType, Area,
	} = {}) {
		const data = {
			"Seq": "20250526",
			"ID": "KS",
			"Key": "chk#az$ip7v6h!wrgm%2si",
			"Func": "resetpassword",
			"data": {
				Area,
				MemberType,
				Mobile
			}
		}

		return request(data, 'KS')
	},


	updateMemberInfo({
		Code,
		Password,
		Name,
		EMail
	}) {
		const data = {
			"Seq": "20250526",
			"ID": "KS",
			"Key": "chk#az$ip7v6h!wrgm%2si",
			"Func": "updmemberdata",
			"data": {
				Code,
				Password,
				Name,
				EMail
			}
		}

		return request(data, 'KS')
	},

	passwordLogin({
		Area,
		Mobile,
		MemberType,
		Password
	}) {
		const data = {
			"Seq": "20250526",
			"ID": "KS",
			"Key": "chk#az$ip7v6h!wrgm%2si",
			"Func": "memberlogin",
			"data": {
				Area,
				Mobile,
				MemberType,
				Password
			}
		}

		return request(data, "KS")
	},

	getAllOrderList({ DateFrom, DateTo }) {
		const data = {
			"Seq": "20250526",
			"ID": "KS",
			"Key": "chk#az$ip7v6h!wrgm%2si",
			"Func": "GetAllOrderList",
			"data": {
				"Token": localStorage.getItem('logingCode'),
				DateFrom,
				DateTo
			}
		}

		return request(data, "KS")

	}
}